import React, { useEffect, useRef, useState } from "react";
import "../styles/Home.css";
import logo from "../assets/logo.png";
import illustration from "../assets/illustration.png";
import { CheckIcon, UploadIcon } from "../Svg";
import { loadStripe } from '@stripe/stripe-js';
import validator from 'validator';
import instance from "../instance";
import pdfLink from '../assets/reglement.pdf';

let stripePromise;

const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
  }

  return stripePromise;
};

const calculerPrix = (meter)=>{
  const prix_par_3 = parseInt(meter/3)*6
  const supplement = (meter%3)*2.5
 
  
  return prix_par_3 + supplement
}
const Home = () => {  
  // REF
  const fileInput = useRef(null);
  const errorRef = useRef()
  // STATE
  const [activeCheckbox, setActiveCheckbox] = useState(false);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [street, setStreet] = useState("");
  const [voie, setVoie] = useState("");
  const [city, setCity] = useState("");
  const [file, setFile] = useState(undefined);
  const [meter, setMeter] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [fileLink, setFileLink] = useState("");
  const [loading,setLoading] = useState(false)
  const [error,setError] = useState("")

  const handleCheckout = async (url) => {
      const stripe = await getStripe();

      const address = voie + ' , ' + street + ' , ' + city
      if(!url) return setError("Pas de fichier")
      // Create a Checkout Session on the server
      const response = await instance.post('/create-checkout-session',JSON.stringify({ meter,fullName,address,phoneNumber,email,fileLink:url }), {
       
        headers: {
          'Content-Type': 'application/json',
        },
        
      });
     
      
      const session = response.data;
    
      // Redirect to Stripe checkout page
      const result = await stripe.redirectToCheckout({
        sessionId: session.id,
      });
    
      if (result.error) {
        // Handle any errors that occur during redirection
        console.error(result.error);
        setLoading(false)
      }
    
    
  };

  const registerUser = async (url)=>{
    const address = voie + ' , ' + street + ' , ' + city
    if(!url) return setError("Pas de fichier")
    try {
      const response = await instance.post('/register-user',JSON.stringify({ meter,fullName,address,phoneNumber,email,fileLink:url }), {
       
        headers: {
          'Content-Type': 'application/json',
        },
        
      });
     
      
      const user = response.data;
      if(user.fullName) window.location.href = "/success?session_id=later"
      console.log(user)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const uploadFileAndCheckout = async (willPay)=>{
 
    const allowedTypes = ["image/jpeg", "image/png","image/jpg","application/pdf"]
    if(!allowedTypes.includes(file.type)) {
      setLoading(false)
      setError('Le fichier doit être une image ou un pdf')
      return
    } 
 

    if (file.size > 5000000 ) {
      setError("Taille de fichier maximum 5mb");
      setLoading(false);
      return;
    }
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", "esprit-libre");
    data.append("cloud_name", "shenzen64");
    try {
      const photoData = await fetch(
        "https://api.cloudinary.com/v1_1/shenzen64/image/upload",
        {
          method: "post",
          body: data,
        }
      ).then((l) => l.json())
      console.log(photoData);
      

      setFileLink(photoData.url)

      if(willPay){
        // Now we can checkout
        handleCheckout(photoData.url)
      } else {
        registerUser(photoData.url)
      }
      return photoData.url
      
    }
      catch(err){
        console.log(error);
        return ""
      }
  }



  const handleSubmit = (willPay) => {


    // Will pay is a variable that indicate if the user will pay with cart now or later with espece

    if(loading) return

    if (fullName && email && phoneNumber && street.length>0 && voie.length>0 && city.length>=2 && meter && file) {

      // Validate Inputs
      if(!validator.isEmail(email)) return setError("Email Invalide")
      if(!validator.isAlpha(fullName.replace(/\s/g, ''))) return setError("Nom et Prénom Invalide")
      if(!validator.isMobilePhone(phoneNumber.replace(/\s/g, ''))) return setError("Numéro de telephone Invalide")
      // Conditions
      if(!activeCheckbox) return setError("Veillez accepter les conditions d'utilisation")
      // Nombre de metre
      if(meter<3) setError("Minimum 3 mètres")
      
      setError("")
      setLoading(true)
      
      uploadFileAndCheckout(willPay)
      
    } else {
      setError("Veuilez Rentrez Toute Les Informations")
    }
  };


  const startServer = async ()=>{
    try {
      const res = await instance.get("/home")
      console.log(res.data);
      
    } catch (error) {
      console.log(error);
      
    }
  }

  // SCROLL TO THE ERROR When there is an error
  useEffect(() => {
    if(error) errorRef.current.scrollIntoView({behavior:'smooth'})
  }, [error]);

  // Une fois sur le site on lance le serveur pour les prochaine requêtes
  useEffect(()=>{
    startServer()
  },[])
  

  return (
    <div className="hero">
      <div className="form__container">
        <div className="header">
          <h3>Réservation place brocante Esprit Libre le 04 Juin 2023 </h3>
          <div className="logo">
            <img src={logo} alt="Logo Esprit Libre" />
          </div>
        </div>
        <div className="flex">
          <div>
            <h2>Nom et Prénom</h2>
            <div className="input__container">
              <input
                type="text"
                value={fullName}
                autoComplete="off"
                onChange={(e) => setFullName(e.target.value)}
              />
            </div>
            <h2>Email</h2>
            <div className="input__container">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <h2>Numéro de Télephone</h2>
            <div className="input__container">
              <input
                type="phone"
                value={phoneNumber}
                autoComplete="off"
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </div>
          </div>
          <div>
            <h3>Adresse Postal</h3>
            <h2>Numero De Voie:</h2>
            <div className="input__container">
              <input
                type="text"
                value={voie}
                autoComplete="off"
                onChange={(e) => setVoie(e.target.value)}
              />
            </div>
            <h2>Voie:</h2>
            <div className="input__container">
              <input
                type="text"
                value={street}
                onChange={(e) => setStreet(e.target.value)}
              />
            </div>
            
            <h2>Ville et code postal:</h2>
            <div className="input__container">
              <input
                type="text"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>
          </div>
        </div>
        <h2>Pièce D'identité:</h2> <span className="pro">Pour les profesionnel, veuillez mettre une copie de votre carte trois volets ou votre extrait K-bis </span>
        <div onClick={()=>fileInput.current.click()} className="upload__btn">
          <UploadIcon />
          Importer un fichier
       
          </div>
          { file ? <span className="filename"> {file.name} </span> : ""}
        <input
         onChange={(e) => setFile(e.target.files[0])}
         ref={fileInput} 
         type="file" 
         accept="image/*, application/pdf"
         style={{ display: "none" }}
        />
        <h2>Nombre de métre Linéaire Souhaité</h2>

        <div className="total blue">
          <div className="input__container small">
            <input
              type="number"
              value={meter}
              onChange={(e) => setMeter(parseInt(e.target.value))
              }
            />
          </div>
          { meter!="" ? (parseInt(meter)>=3 ?  <>Total: <strong>  {calculerPrix(meter)} € </strong></> : "Minimum 3 mètres") : ""}
        </div>
        <div className="total">
          <img src={illustration} alt="Illustration" />
          <span>3m=6€</span>
          <span id="supplement">+ 2.5 € pour chaque mètre supplémentaire</span>
        </div>
        <div className="conditions">
          <div
            onClick={() => setActiveCheckbox(!activeCheckbox)}
            className="checkbox"
          >
            {activeCheckbox && <CheckIcon />}
          </div>
          <div>
          En cochant cette case vous acceptez{" "}
          <a rel="noreferrer" href={pdfLink} target="_blank"> le réglement intérieur du vide grenier / brocante </a >
          </div>
        </div>
        <div className="submit__container" >

        <div onClick={ ()=> handleSubmit(true)} className="submit" style={{cursor:loading ? "not-allowed" : "pointer"}} >

          { loading ? "Chargement...": <>Réserver et payer par carte</>}

          </div>

<div onClick={ ()=>handleSubmit(false) } className="submit inverse">  { loading ? "Chargement...": <> Réserver et payer plus tard en espèce ou par chèque </>} </div>
        </div>
       
      
        <span ref={errorRef} className="error"> {error} </span> <br />
        <span> Si vous avez besoin d'aide, veillez appelez le +33 6 64 87 76 77 </span>
      </div>
    </div>
  );
};

export default Home;
